import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Integrations::AuthenticateSupplier @queryParams={{this.queryParamsHash}} />",{ moduleName: "my-phorest/templates/integrations.hbs" })